<template>
  <MyModal
    :title="title"
    height="auto"
    v-if="isShowFace"
    :className="classNames"
    @closeClick="handleCloseModalClick"
  >
    <div class="my-face-content">
      <div class="top-area">
        <div class="item">
          <div class="label">面积:</div>
          <div class="desc">{{ itemConfig.area }} km²</div>
        </div>
        <div class="item">
          <div class="label">高度:</div>
          <div class="desc">
            <el-select
              v-model="datasetHeight"
              placeholder="选择高度"
              @change="handleDataHeightChange"
            >
              <el-option
                v-for="(v, i) in heightList"
                :key="i"
                :label="v + 'm'"
                :value="v"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!--div class="btn-area">
        <div
          v-for="(item, index) in btnList"
          :key="index"
          :class="[
            'btn-item',
            {
              'is-active': item.elementCode === elementCode,
            },
          ]"
          @click="handleBtnClick(item, index)"
        >
          {{ item.name }}
        </div>
      </div-->
      <div class="data-area">
        <!--el-checkbox
          v-model="isElementChecked"
          label="风速"
          @change="checkboxChange(btnList[0])"
        >
        </el-checkbox-->
        <el-radio
          v-if="isElementChecked"
          :value="legendRange"
          label="2"
          @change="handleRightLegendChange"
          >动态图例</el-radio
        >
        <el-radio
          v-if="isElementChecked"
          :value="legendRange"
          label="1"
          @change="handleLeftLegendChange"
          >固定图例</el-radio
        >
      </div>
      <div
        class="pic-area"
        id="my-node"
        v-if="activeValues.length > 0 && !loading"
      >
        <color-simple
          type="horizontal"
          :colors="colors"
          :values="activeValues"
          :unit="activeUnit"
          width="100%"
        ></color-simple>
        <!-- <img class="img-current" :src="config.tupuUrl" /> -->
      </div>
      <div
        class="pic-loading"
        v-if="loading"
      >
        <div>正在绘制资源图...</div>
      </div>
      <div class="link-area">
        <!-- <el-button type="text" @click="closeTupu">关闭图谱</el-button> -->

        <template v-if="isLogin">
          <!-- <el-button type="text" @click="imgDownLoad">图片下载</el-button>
          <el-button v-if="!fromProjectList" type="text" @click="tupuDownLoad"
            >图谱下载</el-button
          >
          <el-button v-if="!fromProjectList" type="text" @click="handleLXClick"
            >资源遴选</el-button
          > -->
          <!-- <el-button v-if="!isTempItem" type="text" @click="tupuDownLoad"
            >导出</el-button
          > -->
          <el-button type="text" v-if="isTempItem" @click="addResourceItem">保存</el-button>
<!--          <el-button type="text" v-if="!isTempItem" @click="deleteItem">删除</el-button>-->
          <el-button type="text" v-if="!isTempItem && !islx" @click="handleLXClick">资源遴选</el-button>
          <el-button type="text" v-if="!isTempItem && islx" @click="handleLeftClick">关闭遴选</el-button>
        </template>
      </div>
    </div>

    <div v-if="islx" class="my-face-content">
      <div class="form-area">
        <el-form
                size="mini"
                :inline="true"
                ref="form"
                :model="form"
                :rules="rules"
        >
          <el-form-item
                  label="最大坡度"
                  prop="maxSlope"
                  ref="maxSlope"
                  :rules="rules.maxSlope"
          >
            <el-input
                    placeholder="请输入"
                    v-model="form.maxSlope"
            ></el-input>
          </el-form-item>
          <el-form-item
                  label="最低风速"
                  prop="minWspd"
                  ref="minWspd"
                  :rules="rules.minWspd"
          >
            <el-input
                    placeholder="请输入"
                    v-model="form.minWspd"
            ></el-input>
          </el-form-item>
          <el-form-item
                  label="最低海拔"
                  prop="minAlt"
                  ref="minAlt"
                  :rules="rules.minAlt"
          >
            <el-input
                    placeholder="请输入"
                    v-model="form.minAlt"
            ></el-input>
          </el-form-item>
          <el-form-item
                  label="最高海拔"
                  prop="maxAlt"
                  ref="maxAlt"
                  :rules="rules.maxAlt"
          >
            <el-input
                    placeholder="请输入"
                    v-model="form.maxAlt"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
<!--      <div class="btn-wrapper">-->
<!--        <ct-button type="primary" :btnClick="handleLxDClick"-->
<!--          >开始遴选</ct-button-->
<!--        >-->
<!--      </div>-->
      <div class="deploy-btn-wrapper" style="justify-content: center; text-align: center;margin:10px 0;">
        <ct-button size="small" type="primary" :btnClick="lxResult">开始遴选</ct-button>
      </div>
      <div v-if="result.selectCap != null && result.selectArea != null" class="line">
        <div class="lxresult">
          <div>遴选后面积：<span>{{result.selectArea}}</span>km²</div>
          <div style="text-align: right;">可装机容量：<span>{{result.selectCap}}</span>MW</div>
        </div>
        <div style="text-align: right">
          <el-button type="text" @click="exportLxKMZ">导出结果</el-button>
        </div>
      </div>
    </div>
  </MyModal>
</template>

<script>
import { number1} from '@/utils/rules';
import flattenDepth from 'lodash/flattenDepth';
import { FLOW_COLORS } from '@/utils/constants';
import domtoimage from 'dom-to-image';
import {
  parseMapDataToGeoInfo,
  toFixed,
  parseGeoInfoToMapData,
} from '../utils';
import StandInput from './stand-input';
import MyModal from './modal';
import { mapGetters } from 'vuex';
import { getToken } from '@/utils';
export default {
  components: {
    MyModal,
    StandInput,
  },
  props: {
    itemConfig: {
      type: Object,
      default: () => ({}),
    },
    fromProjectList: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rules: {
        maxSlope: [
          number1({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        minWspd: [
          number1({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        minAlt: [
          number1({ min: 0, max: 4000, equal: { min: true, max: true } })
        ],
        maxAlt: [
          number1({ min: 0, max: 6000, equal: { min: true, max: true } })
        ],
      },
      colors: FLOW_COLORS,
      a: '',
      islx: false,
      config: {
        itemName: '',
        elementCode: '',
      },
      heightList: [],
      loading: false,

      windSelectionInfo: {
        avgSpeedYear: null,
        // fullHour: null,
        altitudeTo: null,
        slopeTo: null,
        landUseRatio: null,
        distanceFrom: 90,
        distanceTo: 10000,
      },
      btnList: [
        {
          name: '风速',
          elementCode: 'wspd',
          dyValues: [],
          values: [4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8],
          unit: 'm/s',
        }/*,
        {
          name: '气温',
          elementCode: 't',
          dyValues: [],
          values: [-10, -5, 0, 5, 10, 15, 20, 25, 30],
          unit: '℃',
        },
        {
          name: '气压',
          elementCode: 'p',
          dyValues: [],
          unit: 'hPa',
          values: [],
        },
        {
          name: '风功率',
          elementCode: 'wpd',
          unit: 'W/㎡',
          dyValues: [],
          values: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
        },*/
      ],
      exclusiveList: [],
      datasetCode: '',
      datasetHeight: '',
      elementCode: '',
      legendRange: '',
      itemId: '',
      activeValues: [],
      activeUnit: '',
      picName: '',
      isShowFace: true,
      isElementChecked: true,

      form:{
        maxAlt:null,
        maxSlope:null,
        minAlt:null,
        minWspd:null
      },
      result:{
        selectCap: null,
        selectArea: null,
        selectionJson: null
      }
    };
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapGetters('WindFarm', ['toolUIStatus', 'dataSet']),
    classNames() {
      if (!this.isLogin) {
        return 'not-login';
      } else {
        return '';
      }
    },
    isTempItem() {
      return this.itemConfig.itemId?.indexOf?.('test') > -1;
    }
  },
  watch: {
    config: {
      handler(val) {
        this.$emit('update:itemConfig', val);
      },
    },

    datasetCode: {
      handler(val) {
        this.config.datasetCode = val;
      },
      immediate: true,
    },

    datasetHeight: {
      handler(val) {
        this.config.datasetHeight = val;
      },
      immediate: true,
    },

    elementCode: {
      handler(val) {
        this.config.elementCode = val;
      },
      immediate: true,
    },

    legendRange: {
      handler(val) {
        this.config.legendRange = val;
      },
      immediate: true,
    },

    itemConfig: {
      handler(val, prev) {
        if (!val) {
          this.isShowFace = false;
          return;
        }
        this.isShowFace = true;

        // if (prev) {
        //   this.islx = false;
        // }

        this.config = val;

        const {
          datasetCode = '',
          datasetHeight = '',
          elementCode = '',
          legendRange = '',
          itemId = '',
        } = val;

        if (datasetCode) {
          const item = this.dataSet.find(
            (item) => item.datasetCode === datasetCode
          );
          this.heightList = item?.datasetHeight || [];
          this.datasetCode = datasetCode;
          this.datasetHeight = datasetHeight;
        } else {
          const firstItem = this.dataSet[0];
          this.datasetCode = firstItem?.datasetCode;
          this.heightList = firstItem.datasetHeight;
          this.datasetHeight = this.heightList[0];
        }

        this.elementCode = elementCode || 'wspd';
        this.legendRange = legendRange || '2';

        if (this.datasetCode && this.datasetHeight) {
          this.queryUrl({
            datasetCode: this.datasetCode,
            datasetHeight: this.datasetHeight,
            itemId: itemId,
            elementCode: this.elementCode,
            legendRange: this.legendRange,
          });
        }

        this.form = {
          maxAlt:null,
          maxSlope:null,
          minAlt:null,
          minWspd:null
        },
        this.result = {
          selectCap: null,
          selectArea: null,
          selectionJson: null
        }
        this.handleLeftClick();
      },
      immediate: true,
      // deep: true
    }
  },
  created() {
    this.$bus.$on('createLXLimitAdd', this.createLxLimitAdd);
  },
  beforeDestroy() {
    this.$bus.$off('createLXLimitAdd', this.createLxLimitAdd);

    this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
      type: 'lx-limit-area',
      data: [],
    });

    this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
      type: 'lx-result-area',
      data: [],
    });
  },
  mounted() {},
  methods: {
    exportLxKMZ() {
      const apiKey = getToken();
      const loading = this.$loading({
        text: '正在导出KMZ，请稍后...',
        spinner: 'el-icon-loading',
      });

      this.$fetch(`/windfarm/project/plane/downloadItemSelectionKmzFile?itemId=${this.config.itemId}&datasetHeight=${this.datasetHeight}`, {
        method: 'get',
        showError: true,
        showLoading: {
          mask: true,
          loadingContent: '正在导出KMZ，请稍后...'
        },
        noJudge: true,
        responseType: 'blob',
      })
              .then(res => {
                if(res.status == 401){
                  loading.close();
                  this.errorMessage(res.data);
                  return;
                }
                const blob = new Blob([res.data]);

                var link = document.createElement('a');
                var fileURL = URL.createObjectURL(blob);
                link.target = '_blank';
                link.href = fileURL;
                let docName = this.itemConfig.itemName + "遴选结果.kmz";
                link.download = docName; //文件名称
                link.click();
                loading.close();
              })
              .catch(() => {});
    },
    async errorMessage(data){
      const text = await data.text(); // 将 Blob 转为文本
      this.$message.error(text);
    },
    addResourceItem() {
      this.$emit('addItem');
    },
    deleteItem() {
      this.$emit('deleteItem');
    },
    handleCloseModalClick() {
      this.isShowFace = false;
      this.config = null;
    },
    getActiveUnit() {
      if (!this.elementCode) {
        return '';
      }
      return this.btnList.find(i => i.elementCode === this.elementCode)?.unit;
    },
    getActiveValues() {
      if (!this.elementCode) {
        return [];
      }

      if (this.legendRange == 2) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .dyValues;
      }
      if (this.legendRange == 1) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .values;
      }
      return [];
    },
    updateElemenCodeValue(max, min) {
      if (this.legendRange == 2 || this.elementCode === 'p') {
        const unit = (max - min) / 10;
        const newArr = new Array(11).fill('');

        const item = this.btnList.find(
          (i) => i.elementCode === this.elementCode
        );

        item.dyValues = newArr.map((i, index) => {
          let fixUnit = 0;
          if (this.elementCode === 'wspd') {
            fixUnit = 1;
          }

          return toFixed(min + unit * index, fixUnit);
        });

        if (this.elementCode === 'p') {
          const item = this.btnList.find(
            (i) => i.elementCode === this.elementCode
          );
          item.values = newArr.map((i, index) => {
            let fixUnit = 0;
            if (this.elementCode === 'wspd') {
              fixUnit = 1;
            }
            return toFixed(min + unit * index, fixUnit);
          });
        }
      }
    },
    handleLxDClick() {
      let arr = [];

      this.exclusiveList.forEach(i => {
        arr.push(i.data);
      });

      const newArr = arr.map(i => {
        return i.map((item) => [item.lng, item.lat]);
      });

      const strs = newArr
        .map((item) => {
          return JSON.stringify({
            type: 'Polygon',
            coordinates: [item],
          });
        })
        .join(';');

      this.$fetch({
        method: 'POST',
        url: '/windfarm/station/windSelection',
        data: {
          ...this.windSelectionInfo,
          geometryInfos: strs,
          itemId: this.itemConfig.itemId,
          dataSet: this.itemConfig.datasetCode,
          dataHeight: this.itemConfig.datasetHeight,
        },
        showError: true,
        showLoading: true,
        showSuccess: true,
      }).then(() => {
        this.querySelectionArea();
      });
    },
    handleLimitClick(value) {
      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['lxLimitAdd'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'lxLimitAdd',
        value: !status,
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawPolygon',
        value: !status,
      });
    },
    handleViewClick(item) {
      item.isShow = !item.isShow;
      const arr = this.exclusiveList
        .filter(i => !!i.isShow)
        .map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr,
      });
    },

    handleDelLimitClick(item, index) {
      this.exclusiveList.splice(index, 1);
      const arr = this.exclusiveList
        .filter(i => !!i.isShow)
        .map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr,
      });
    },
    createLxLimitAdd(data) {
      this.handleLimitClick(false);

      const str = parseMapDataToGeoInfo(data, 'Polygon');
      this.exclusiveList.push({
        data: data,
        geo: str,
        isShow: true,
      });

      const arr = this.exclusiveList
        .filter(i => !!i.isShow)
        .map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr,
      });
    },
    querySelectionArea() {
      function getMap(array, type) {
        if (!array.length) return array;

        if (Array.isArray(array) && typeof array[0] === 'number') {
          array[0] = {
            type,
            lat: array[1],
            lng: array[0],
          };

          array.length = 1;
          return 'change';
          // Reflect.deleteProperty(array, '1');
        } else {
          for (let i = 0; i < array.length; i++) {
            let flag = getMap(array[i], type);

            if (flag === 'change') {
              array[i] = array[i][0];
            }
          }
        }
      }
      this.$fetch('/windfarm/project/plane/getWindSelectCapacity', {
        showError: true,
        params: {
          datasetHeight: this.datasetHeight,
          itemId: this.config.itemId,
        },
      }).then((res) => {
        if(res.code == 0){
          const {maxAlt,maxSlope,minAlt,minWspd,selectCap=null,selectArea=null,selectionJson=null} = res.data;
          this.form = {maxAlt,maxSlope,minAlt,minWspd};
          this.result = {selectCap,selectArea,selectionJson};
          const lxMapData = selectionJson ? JSON.parse(selectionJson)['coordinates'] : [];

          getMap(lxMapData, 'lx-result-area');

          this.$store.commit('WindFarm/SET_RAW_POLYGONS_ARR', {
            type: 'lx-result-area',
            data: lxMapData,
          });
        }else{
          this.$message.error(res.message);
        }
      });
    },
    lxResult() {
      function getMap(array, type) {
        if (!array.length) return array;

        if (Array.isArray(array) && typeof array[0] === 'number') {
          array[0] = {
            type,
            lat: array[1],
            lng: array[0],
          };

          array.length = 1;
          return 'change';
          // Reflect.deleteProperty(array, '1');
        } else {
          for (let i = 0; i < array.length; i++) {
            let flag = getMap(array[i], type);

            if (flag === 'change') {
              array[i] = array[i][0];
            }
          }
        }
      }
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          if(this.form.minAlt > this.form.maxAlt){
            this.$message.error("最低海拔不能大于最高海拔");
            return;
          }
          this.$fetch('/windfarm/project/plane/saveWindSelectCapacity', {
            showError: true,
            method: 'post',
            showLoading: {
              mask: true,
            },
            params: {
              datasetHeight: this.datasetHeight,
              apiKey: getToken(),
              itemId: this.config.itemId,
              ...this.form
            },
          }).then((res) => {
            if(res.code == 0){
              const {selectCap=null,selectArea=null,selectionJson=null} = res.data;
              this.result = {selectCap,selectArea,selectionJson};
              const lxMapData = selectionJson ? selectionJson['coordinates'] : [];

              getMap(lxMapData, 'lx-result-area');

              this.$store.commit('WindFarm/SET_RAW_POLYGONS_ARR', {
                type: 'lx-result-area',
                data: lxMapData,
              });
            }else{
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    handleLeftLegendChange() {
      this.legendRange = '1';
      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange,
      });
    },
    handleRightLegendChange() {
      this.legendRange = '2';
      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange,
      });
    },
    handleBtnClick(item) {
      if (this.elementCode === item.elementCode) {
        return this.closeTupu();
      }

      this.elementCode = item.elementCode;

      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange,
      });
    },
    checkboxChange(item) {
      if (this.elementCode === "wspd") {
        return this.closeTupu();
      }

      this.elementCode = item.elementCode;

      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange,
      });
    },
    handleLXClick() {
      this.islx = true;
      this.querySelectionArea();
    },
    handleLeftClick() {
      this.islx = false;
      this.$store.commit('WindFarm/SET_RAW_POLYGONS_ARR', {
        type: 'lx-result-area',
        data: [],
      });
    },
    handleSelectChange(val) {
      const item = this.dataSet.find((item) => item.datasetCode === val);
      this.heightList = item?.datasetHeight;
      this.datasetHeight = this.heightList[0] || '';

      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange,
      });
    },
    handleDataHeightChange() {
      this.querySelectionArea();
      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange,
      });
    },
    queryUrl(params) {
      if (!params.elementCode) return;

      const {
        datasetCode = '',
        datasetHeight = '',
        itemId = '',
        elementCode = '',
        legendRange = '',
      } = params;

      const isTemp = itemId?.indexOf?.('test') > -1;

      const xzCode = this.itemConfig.code || this.itemConfig.adcode;

      this.loading = true;
      this.$postForm('/windfarm/project/plane/getElementsPicPath', {
        data: {
          datasetCode,
          datasetHeight,
          itemId: isTemp ? '0' : itemId,
          elementCode,
          legendRange,
          geometryInfo: xzCode ? undefined : this.itemConfig.geometryInfo,
          adcode: xzCode || undefined,
        },
        // noKey: this.fromProjectList,
        showError: true,
      }).then((res) => {
        this.loading = false;
        const { data } = res;
        const { atlas, max, min } = data;
        const tupuUrl = process.env.VUE_APP_API_HOST + '/windfarm' + atlas;
        // todo更新URL

        const arr = atlas.split('?');
        this.picName = arr[1].split('=')[1];

        this.updateElemenCodeValue(max, min);

        this.activeValues = this.getActiveValues();
        this.activeUnit = this.getActiveUnit();

        this.$emit('updateImg', {
          isTemp:isTemp,
          id: itemId,
          url: tupuUrl + '&version=' + new Date().valueOf(),
        });
      });
    },
    imgDownLoad() {
      if (!this.picName) {
        return this.$message.warning('图片还没准备好，请稍后再试');
      }

      fetch(
        `${
          process.env.VUE_APP_API_HOST
        }/windfarm/project/plane/getElementsPic?url=${
          this.picName
        }&apiKey=${getToken()}&version=${new Date().valueOf()}`
      )
        .then((res) => {
          if (!res) {
            return this.$message.error('导出错误');
          }

          return res.blob();
        })
        .then((data) => {
          if (!data) return;

          const blob = new Blob([data]);

          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);

          link.target = '_blank';
          link.href = fileURL;
          link.download = this.picName;
          link.click();
        });

      // this.$fetch(`/windfarm/project/plane/getElementsPic`, {
      //   params: {
      //     url: this.picName,
      //     version: new Date().valueOf()
      //   },
      //   showLoading: true,
      //   noJudge: true
      // }).then(res => {
      //   const blob = new Blob([res.data]);

      //   var link = document.createElement('a');
      //   var fileURL = URL.createObjectURL(blob);

      //   link.target = '_blank';
      //   link.href = fileURL;
      //   link.download = this.picName;
      //   link.click();
      // });

      // window.open(
      //   `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/getElementsPic?url=${this.picName}`,
      //   '__parent'
      // );
      // const link = document.createElement('a');
      // link.href = `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/getElementsPic?url=${this.picName}`;
      // link.download = this.picName;
      // link.target = '_blank';
      // link.style.display = 'none';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },
    closeTupu() {
      this.$emit('updateImg', {
        id: this.itemConfig.itemId,
        url: '',
      });

      this.elementCode = '';
      this.activeValues = this.getActiveValues();
    },

    tupuDownLoad() {
      const node = document.getElementById('my-node');
      domtoimage.toJpeg(node).then(async (dataurl) => {
        const file = new File([dataURItoBlob(dataurl)], '图例.jpg', {
          type: 'jpg',
        });
        const formData = new FormData();
        // const geometryInfos = this.itemConfig.geometryInfo;

        // let data = parseGeoInfoToMapData(geometryInfos)[0];

        // if (this.itemConfig.itemType === 4) {
        //   const result = await this.$fetch(
        //     '/windfarm/project/plane/getKmzFile',
        //     {
        //       showError: true,
        //       params: {
        //         // 拿默认的
        //         regionId: this.itemConfig.adcode
        //       }
        //     }
        //   ).then(res => {
        //     const { data = {} } = res || [];
        //     const { regionBoundary = { coordinates: '' } } = data;

        //     let result = JSON.parse(regionBoundary).coordinates || [];
        //     return result[0][0].map(i => ({ lat: i[1], lng: i[0] }));
        //   });

        //   data = result;
        // }

        // const { maxLat, maxLon, minLat, minLon } = this.getMax(data);

        formData.append('apiKey', getToken());
        formData.append('datasetHeight', this.datasetHeight);
        formData.append('datasetCode', this.datasetCode);
        // formData.append('datasetYear', this.datasetYear);
        formData.append('elementCode', this.elementCode);
        formData.append('file', file);
        formData.append('itemId', this.itemConfig.itemId);
        formData.append('legendRange', this.legendRange);
        // formData.append('picName', this.picName);
        // formData.append('maxLat', maxLat);
        // formData.append('maxLon', maxLon);
        // formData.append('minLat', minLat);
        // formData.append('minLon', minLon);

        fetch({
          method: 'post',
          url: '/windfarm/project/plane/getKmzFile',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((res) => {
            return res.blob();
          })
          .then((res) => {
            // const download = `${this.itemConfig.itemId}_${this.datasetHeight}_${this.elementCode}_${this.legendRange}.kmz`;
            // window.open(
            //   `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/downKmz?kmzName=${download}`,
            //   '_parent'
            // );

            const blob = new Blob([res]);

            var link = document.createElement('a');
            var fileURL = URL.createObjectURL(blob);

            link.target = '_blank';
            link.href = fileURL;
            link.download = `${this.itemConfig.itemId}_${this.datasetHeight}_${this.elementCode}_${this.legendRange}.kmz`;
            link.click();
          });
      });

      function dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        //Old Code
        //write the ArrayBuffer to a blob, and you're done
        //var bb = new BlobBuilder();
        //bb.append(ab);
        //return bb.getBlob(mimeString);

        //New Code
        return new Blob([ab], { type: mimeString });
      }
    },

    getMax(data) {
      let maxLat = -1000;
      let maxLon = -1000;
      let minLat = 1000;
      let minLon = 1000;

      const newData = flattenDepth(data, 4);

      newData.forEach((item) => {
        const { lat, lng } = item;

        if (maxLat < lat) {
          maxLat = lat;
        }

        if (minLat > lat) {
          minLat = lat;
        }

        if (maxLon < lng) {
          maxLon = lng;
        }

        if (minLon > lng) {
          minLon = lng;
        }
      });

      return {
        maxLat,
        minLat,
        maxLon,
        minLon,
      };
    },
  },
};
</script>

<style lang="less" scoped>
  ::v-deep.el-form-item--mini.el-form-item{
    width: 48%;
    margin-right:5px;
  }
  ::v-deep .el-form-item--mini.el-form-item{
    margin-bottom: 10px;
  }
  ::v-deep .el-form-item--mini .el-form-item__label{
    padding-right:5px;
  }
  ::v-deep .el-form-item--mini .el-form-item__content{
    width: 80px;
  }
  .lxresult{
    display: flex;
    justify-content: space-between;
    padding:12px 0 10px 0;
    font-size: 12px;
    span{
      color:#1890ff;
      padding:0 2px 0 3px;
      font-size: 14px;
    }
  }
.my-face-content {
  padding: 0 10px;

  .form-area {
    background-color: #fff;
    border-radius: 7px;
    padding: 15px 0 0 0;
    display: flex;
    flex-wrap: wrap;

    .form-item {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      width: 50%;
      &.sp {
        margin-top: 15px;
      }
    }

    .key {
      margin-right: 5px;
      width: 60px;
      line-height: 30px;
      font-weight: 500;
      text-align: right;
    }
    .value {
      flex:1;
    }
  }
}
.top-area {
  .item {
    height: 36px;
    display: flex;
    align-items: center;
    padding: 3px 0px;
    .label {
      color: @black-color;
      width: 48px;
      text-align: right;
      margin-right: 10px;
      padding: 0.2em 3em 0.01em 1em;
    }
    .desc {
      color: @black-color;
    }
  }
}
.btn-area {
  margin-top: 10px;
  display: flex;
  .btn-item {
    display: inline-block;
    padding: 5px;
    line-height: 20px;
    flex: 1;
    text-align: center;
    cursor: pointer;
    margin-bottom: 13px;
    background: #133C62;
    border-radius: 5px;
    color: #fff;
    &:not(:last-child) {
      margin-right: 5px;
    }

    &.is-active {
      background-color: #1890ff;
      color: #fff;
    }
  }
}

.pic-area {
  .img-current {
    width: 100%;
  }
}
.pic-loading {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.link-area {
  text-align: right;
  padding: 0 10px;
  //margin-top: 10px;
  // display: flex;
}

.data-area {
  padding: 10px 0 0 70px;
}
.lx-limit-area {
  margin-top: 10px;

  .area-content {
    margin-top: 10px;
    padding: 0px 10px;
    max-height: 120px;
    overflow: auto;
  }
  .depoly-content-item {
    &:nth-child(n + 1) {
      margin-top: 5px;
    }
    display: flex;
    align-items: center;
    position: relative;
    & > span {
      display: flex;
      align-items: center;
    }

    .btns {
      display: flex;
      align-items: center;
      position: absolute;
      right: 0;
      i {
        display: flex;
        align-items: center;
        cursor: pointer;

        &.is-active {
          color: #3cc2e6;
        }
        &:hover {
          color: #478beb;
        }
        &:first-child {
          margin-right: 10px;
        }
      }
    }
  }

  .my-title {
    font-weight: normal;
    font-size: 16px;
    color: #000;
    padding: 0px 10px;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0px;
      top: 1px;
      border-radius: 3px;
      width: 5px;
      height: 100%;
      background-color: #015aac;
    }
    i {
      cursor: pointer;
      &:hover {
        color: #478beb;
      }
      &.is-active {
        color: #0159ac;
      }
    }
  }
}
.btn-wrapper {
  margin-top: 10px;
  text-align: right;
}
.line {
  border-top: 1px solid rgb(220, 223, 230);
}
</style>

<style lang="less">
.my-face-content {
  .el-radio__label {
    color: @black-color;
  }
  .el-radio.is-checked {
    .el-radio__label {
      color: #1890ff;
    }
  }
}
</style>
